module.exports = __webpack_public_path__ + "static/dolo__background--transparent-1f61787dea57229049a5cdd9d2ef4993.png";